import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { generatePath, useParams } from 'react-router'
import styled from 'styled-components'
import { Tooltip } from 'antd'
import { colours } from '@qflow/theme'

import { MODULES } from 'portal/lib/constants'
import { ClickableLink, icons } from 'portal/lib/primitives'
import * as ROUTES from 'portal/routes'
import { useModuleIds } from 'portal/lib/hooks'

export const RecordLink = (setCellId, filters, updateFilters) => {
  const handleResetFilters = () => {
    for (const key in filters) {
      if (typeof filters[key] === 'object' && filters[key].length > 0) {
        updateFilters(key, [])
      } else if (typeof filters[key] === 'string') {
        updateFilters(key, '')
      }
    }
  }

  return {
    title: (
      <Tooltip title="Reset filters">
        <ResetFilters aria-label="Reset filters" onClick={handleResetFilters}>
          <icons.ResetFilters size="24px" colour="currentColor" />
        </ResetFilters>
      </Tooltip>
    ),
    width: '4rem',
    render: (rowData, _, index) => {
      if (
        !rowData.record ||
        !rowData.record.recordId ||
        rowData.record.recordId.length < 3
      ) {
        return ''
      }
      return <RecordLinkRenderer rowData={rowData} record={rowData.record} />
    },
    align: 'right',
    onCell: setCellId
  }
}

/** @param {{accountId: string, projectId: string, moduleName?: string, module: string}} params */
export const getRecordLinkUri = (params, moduleName, recordId) => {
  const route = MODULES.select(moduleName, {
    waste: ROUTES.WASTE_RECORD_DETAILS,
    delivery: ROUTES.DELIVERY_RECORD_DETAILS
  })

  return generatePath(route, {
    ...params,
    recordId: recordId
  })
}

const RecordLinkRenderer = ({ rowData, record }) => {
  const params = useParams()
  const { moduleName } = useModuleIds()
  const { recordId } = record

  const uri = useMemo(() => {
    return getRecordLinkUri(params, moduleName, recordId)
  }, [moduleName, params, recordId])

  return (
    <StyledClickableLink
      id="navigateToDetailsBtn"
      to={uri}
      disabled={rowData.removed}
    >
      {rowData.removed ? (
        <div />
      ) : (
        <Tooltip title="View record">
          <icons.ViewRecord />
        </Tooltip>
      )}
    </StyledClickableLink>
  )
}

RecordLinkRenderer.propTypes = {
  rowData: PropTypes.object.isRequired,
  record: PropTypes.object.isRequired
}

const ResetFilters = styled.button`
  height: 32px;
  width: 32px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: none;
  background-color: transparent;

  &:hover {
    color: ${colours.TEAL};
  }
`
const StyledClickableLink = styled(ClickableLink)`
  height: 32px;
  width: 32px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    color: ${colours.TEAL};
  }
`
